import React from 'react';
import { PageHeader } from '../components/page/PageHeader';
import { FeatureRow } from '../components/page/FeatureRow';
import { CtaBand } from '../components/page/CtaBand';
import { Counter } from '../components/ui/Counter';
import { Reveal } from '../components/ui/Reveal';
import { PlayCircle } from 'lucide-react';
import { LayeredRosterDatabaseMockup, LayeredCastingCallMockup, LayeredDirectoryMockup, LayeredAListMockup } from '../components/page/BrandMockups';
import { HowMarketplaceWorks } from '../components/page/HowMarketplaceWorks';
import { Testimonials, BRAND_TESTIMONIALS } from '../components/Testimonials';
const DEMO_VIDEO_URL = 'https://www.youtube.com/watch?v=U2sV81k41u4&pp=0gcJCUwLAYcqIYzv';
export const ForBrands = () => {
  return <>
      <PageHeader eyebrow="For Brands" eyebrowClass="bg-blue-50 text-blue-700 border border-blue-200" title="Book high-level talent at scale" subtitle="Zano makes it accessible and scalable to book elite talent. It's no longer gate-kept behind closed doors or limited to your personal network. Anyone can post a casting call, but approval is required to access the premium roster database and agency directory." primaryCta={{
      label: 'Start Free Trial',
      to: '/pricing'
    }} secondaryCta={{
      label: 'Watch demo video',
      href: DEMO_VIDEO_URL,
      newTab: true,
      icon: <PlayCircle size={18} className="mr-1.5" data-id="element-1998" />
    }} data-id="element-1997" />

      {/* Metrics strip */}
      <section className="border-y border-gray-100 bg-gray-50/60 py-10" data-id="element-1999">
        <div className="max-w-5xl mx-auto px-4 grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-2000">
          {[{
          v: <Counter to={400} suffix="+" data-id="element-2001" />,
          l: 'Talent agencies'
        }, {
          v: <Counter to={6000} suffix="+" data-id="element-2002" />,
          l: 'Represented creators'
        }, {
          v: <Counter to={100} suffix="" data-id="element-2003" />,
          l: 'Avg submissions / 24h'
        }, {
          v: <Counter to={500} prefix="$" suffix="k+" data-id="element-2004" />,
          l: 'GMV generated'
        }].map((s, i) => <Reveal key={i} delay={i * 0.08} data-id="element-2005">
              <p className="text-3xl font-bold text-zano-pink" data-id="element-2006">{s.v}</p>
              <p className="text-sm text-gray-600 mt-1" data-id="element-2007">{s.l}</p>
            </Reveal>)}
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 divide-y divide-gray-100" data-id="element-2008">
        <FeatureRow eyebrow="Accessible Discovery" title="Search a live roster database" body="Reach far beyond your personal network. Search 6,000+ represented creators across 400+ agencies in one place, with live performance data kept current by Zano." bullets={['Filter by followers, engagement rate, and location', 'See live stats for TikTok, YouTube, and Instagram', 'Find direct contact info for talent managers']} visual={<LayeredRosterDatabaseMockup data-id="element-2010" />} data-id="element-2009" />
        <FeatureRow eyebrow="Direct Access" title="Partner with A-list talent instantly" body="When you want to partner with A-list talent like Charli D'Amelio, Tessa Brooks, or Amanda Cerny, you can just search them in the database. See exactly who they are represented by, along with their talent manager's specific email address and contact phone number. Booking A-list talent is quick and efficient in the right network, and we keep growing our talent agency supply." visual={<LayeredAListMockup data-id="element-2012" />} flip data-id="element-2011" />
        <FeatureRow eyebrow="Scalable Sourcing" title="Get custom submissions in hours" body="Post a campaign brief specifying your goal, deliverables, and budget. It blasts instantly to 400+ talent agencies who submit their best fit, scaling your outreach instantly." bullets={['Receive ~100 custom submissions within 24 hours', 'Review custom quotes and notes from managers', 'Filter submissions and take the conversation to email']} visual={<LayeredCastingCallMockup data-id="element-2014" />} data-id="element-2013" />
        <FeatureRow eyebrow="Open Doors" title="The talent agency directory" body="See exactly who represents who. Browse the directory to view high-level rosters and find the right point of contact for the industry's top agencies." bullets={['List of all talent agencies on Zano', 'High-level view of their roster size', 'Direct access to agency websites and general POCs']} visual={<LayeredDirectoryMockup data-id="element-2016" />} flip data-id="element-2015" />
      </div>

      <HowMarketplaceWorks audience="brands" data-id="element-2017" />

      <Testimonials title="What brands and agencies are saying" items={BRAND_TESTIMONIALS} data-id="element-2018" />
      <CtaBand title="Elite talent, open to everyone" subtitle="Join the brands using Zano to access and scale their elite talent bookings." primaryCta={{
      label: 'Start Free Trial',
      to: '/pricing'
    }} secondaryCta={{
      label: 'Watch demo video',
      href: DEMO_VIDEO_URL,
      newTab: true,
      icon: <PlayCircle size={18} className="mr-1.5" data-id="element-2020" />
    }} data-id="element-2019" />
    </>;
};